import isFunction from "lodash/isFunction"
import visible from "../../mixins/visible"
import scrollbar from "../../mixins/scrollbar"
import PopupManager from "./popup-manager"

export default {
  props: {
    escClosable: {
      type: Boolean,
      default: true,
    },
    beforeClose: {
      type: Function,
      default: () => true,
    },
    maskClosable: {
      type: Boolean,
      default: true,
    },
    mask: {
      type: Boolean,
      default: true,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    zIndex: {
      type: Number,
    },
  },
  mixins: [visible, scrollbar],
  data() {
    return {
      closing: false,
      realZIndex: this.zIndex,
    }
  },
  watch: {
    localVisible(value) {
      if (value) {
        PopupManager.open(this)
      } else {
        PopupManager.close(this)
      }
    },
  },
  mounted() {
    PopupManager.register(this)
    if (this.localVisible) {
      PopupManager.open(this)
    }
  },
  beforeDestroy() {
    PopupManager.close(this)
    this.removeScrollEffect()
  },
  methods: {
    setZIndex(zIndex) {
      this.realZIndex = this.zIndex || zIndex
    },
    getZIndex() {
      return this.zIndex
    },
    isValid(val) {
      return val === undefined || (typeof val === "boolean" && val)
    },

    close(reason) {
      if (this.closing) {
        return Promise.reject(false)
      }
      this.closing = true
      const beforeClose = isFunction(this.beforeClose) ? this.beforeClose(this, reason) : true
      return Promise.resolve(beforeClose)
        .catch(() => false)
        .then(res => {
          if (this.isValid(res)) {
            this.doClose(reason)
          }
          this.closing = false
        })
    },
    doClose(reason) {
      this.localVisible = false
      this.$emit("close", reason)
      this.onClose(reason)
    },
    handleBeforeTransition() {
      this.addScrollEffect()
    },
    handleAfterTransition() {
      this.removeScrollEffect()
    },
  },
}
